import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { sketchApp, type AppSketch } from '@api/appBuilder';
import { GENERIC_SKETCH, SKETCH_WAIT_MS } from './sketch.constants';

/** The sketch is only a show: a failed or slow guess falls back to the generic layout. */
export const useAppSketch = (appKey: string, brief: string | null): AppSketch | null => {
  const [waited, setWaited] = useState(false);
  const sketch = useQuery({
    queryKey: ['app-builder', 'sketch', appKey, brief],
    queryFn: () => sketchApp(appKey, brief ?? ''),
    enabled: Boolean(brief?.trim()),
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  });

  useEffect(() => {
    const id = window.setTimeout(() => setWaited(true), SKETCH_WAIT_MS);
    return () => window.clearTimeout(id);
  }, []);

  if (sketch.data) return sketch.data;
  if (sketch.isError || waited || !brief?.trim()) return GENERIC_SKETCH;
  return null;
};
